import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { TbReportMoney } from 'react-icons/tb';
import { formatCurrency } from 'react-data-formatter';
import { Container, Div, Title, Subtitle, StatusLabel } from './styles';

function ReportItem({ report }) {
  return (
    <Container>
      <div className="description">
        <div className="iconReport">
          <TbReportMoney size={23} />
        </div>

        <Div>
          <Title>{moment(report?.created_at).format('DD/MM/YYYY HH:mm')}</Title>
          <Subtitle>Data Geração Relatório</Subtitle>
        </Div>

        <Div>
          <Title>
            {report?.valor_total_billet != null ? formatCurrency(report.valor_total_billet) : 'indisponivel'}
          </Title>
          <Subtitle>Valor Boleto (R$)</Subtitle>
        </Div>

        <Div>
          <StatusLabel baixada={report?.parcelas_baixadas}>{report?.parcelas_baixadas ? 'Sim' : 'Não'}</StatusLabel>
          <Subtitle>Parcelas baixadas</Subtitle>
        </Div>
      </div>
    </Container>
  );
}

export default ReportItem;
